export enum TaxCode {
  GST = 'GST',
  VAT = 'VAT',
  SalesTax = 'sales tax',
}
